/* istanbul ignore file */
export enum EventBookingStatus {
  Confirmed = "confirmed",
  Waitlist = "waitlist",
  Cancelled = "cancelled"
}
